const getTestDriveRedirectUrl = configuration =>
  configuration?.testDrive?.redirectUrl;

module.exports = { getTestDriveRedirectUrl };
